<template>
    <div>
      <el-dialog title="Ачааны төлөв өөрчлөх" :visible.sync="this.$root.checkTrackCodeDialog" :before-close="handleClose" width="350px" center>
        <el-form :model="checkTrackCodeForm" :rules="rules" ref="checkTrackCodeForm">
          <el-form-item prop="description" label="Тайлбар оруулна уу">
            <el-input type="textarea" v-model="checkTrackCodeForm.description"></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="22">
              <el-button class="w-100" type="success" @click="getTrackCodeDetail()">Хадгалах</el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-dialog>
    </div>
  </template>

<script>
import services from '@/helpers/services'

export default {
  data () {
    return {
      checkTrackCodeForm: {
        description: null,
        company_id: 1,
        is_change: this.isChange,
        type: this.transactionTypeValue,
        progress_id: this.progressId
      },
      rules: {
        description: [{ required: true, message: 'Тайлбар оруулна уу', trigger: 'blur' }]
      }
    }
  },
  props: {
    isChange: {
      type: String
    },
    transactionTypeValue: {
      type: String
    },
    progressId: {
      type: Number
    }
  },
  created () {
    this.initData()
  },
  methods: {
    initData () {
      this.checkTrackCodeForm.is_change = this.isChange
      this.checkTrackCodeForm.type = this.transactionTypeValue
      this.checkTrackCodeForm.progress_id = this.progressId
    },
    async getTrackCodeDetail () {
      this.$refs.checkTrackCodeForm.validate((valid) => {
        if (valid) {
          this.$root.fullscreenLoading = true
          const payload = this.checkTrackCodeForm
          const response = services.createTypeCheckTrackCode(payload)
          if (response) {
            this.$root.fullscreenLoading = false
            this.$notify({
              title: 'Амжилттай',
              message: 'Амжилттай',
              type: 'success',
              duration: 3000
            })
            this.handleClose()
            this.$emit('refreshData')
          }
        } else {
          this.$root.fullscreenLoading = false
          this.$notify({
            title: 'Анхааруулга',
            message: 'Заавал бөглөх талбаруудыг бөглөнө үү.',
            type: 'warning',
            duration: 3000
          })
        }
      })
    },
    handleClose () {
      this.$root.checkTrackCodeDialog = false
    }
    // returnStatusValue (data) {
    //   const result = this.$root.statusArray.find(element => element.value === data)
    //   if (result) {
    //     return result.label
    //   } else {
    //     return 'empty'
    //   }
    // },
    // async getTrackCodeDetail () {
    //   try {
    //     this.$root.fullscreenLoading = true
    //     const payload = { is_change: 'update', progress_track_code_id: this.trackCodeDetail.id, description: description }
    //     const response = await services.getTrackCodeById(this.progressId)
    //     if (response) {
    //       this.trackCodeDetail = response.data
    //       this.$root.fullscreenLoading = false
    //     }
    //   } catch (error) {
    //     this.$notify({
    //       title: 'Амжилтгүй',
    //       message: 'Өгөгдөл татхад алдаа гарлаа. ' + error,
    //       type: 'error'
    //     })
    //     this.$root.fullscreenLoading = false
    //   }
    // }
  }
}
</script>

<style>
</style>
